<template>
  <!-- handles if Certificate async fetch hasn't been received yet-->
  <loading :loading="!Boolean(handler.certificate)">
    <template #loading>
      <collapsible-section
          :control-name="dropdownControlId"
          :id="dropdownControlId"
          :is-open="false"
          disabled
          class="collapse-item"
      >
        <template #section-header>
          <xpinner/>
        </template>
      </collapsible-section>
    </template>

    <template #loaded>
      <collapsible-section
          class="collapse-item"
          :is-open="false"
          :id="`certificateDynamicInputsCollapse-${certificate.client_id}-${dropdownControlId}`"
          control-name="certificateDynamicInputsCollapse"
      >
        <template #section-header>
          <row>
            <prefix>
              <icon :glyph="varIOClass(handler.variable)"/>
            </prefix>
            <column>
              {{ handler.rootHeader }}
            </column>
          </row>
        </template>

        <template #section-contents>
          <collapsible-section
              class="collapse-item"
              :id="`certificateDynamicInputsPropertiesCollapse-${certificate.id}-${dropdownControlId}`"
              control-name="certificateDynamicInputsPropertiesCollapse"
              :is-open="true"
          >
            <template #section-header>
              Properties
            </template>

            <template #section-contents>
              <dynamic-input-section-data
                  :handler="handler"
                  :q="q"
                  :section="dynamicInputsSection"
                  :parent-tree-context="computedChildTreeContext"
                  @select="select"
              ></dynamic-input-section-data>
            </template>
          </collapsible-section>
        </template>
      </collapsible-section>
    </template>
  </loading>
</template>

<script lang="ts">
import Vue from 'vue';
import handlerComponentsMixin from "~/components/dynamicFieldsTrees/mixins/handlerComponentsMixin";
import DynamicElementMixin from "~/components/dynamicFieldsTrees/handlerComponents/common/dynamic-element-mixin.vue";
import handlerTreeContextMixin from "~/components/dynamicFieldsTrees/mixins/handlerTreeContextMixin";
import DynamicInputSectionData from "~/components/dynamicFieldsTrees/handlerComponents/dynamic-input-section-data.vue";
import ProcessFlowCertificateDynamicInputsHandler from "~/models/dynamicFields/handlers/processFlows/processFlowCertificateDynamicInputsHandler";
import {TCertificate} from "../../../../formability/certificateBuilder/models/certificate";
import {IDynamicInputsConfig, IDynamicTreeContext} from "~/interfaces/dynamicFieldsInterfaces";

export default Vue.extend({
  mixins: [handlerComponentsMixin, DynamicElementMixin, handlerTreeContextMixin],
  components: {
    DynamicInputSectionData,
  },
  props: {
    handler: {
      type: Object as () => ProcessFlowCertificateDynamicInputsHandler,
      required: true,
    },
  },
  computed: {
    certificate(): TCertificate {
      return this.handler.certificate;
    },
    dynamicInputsSection(): Pick<IDynamicInputsConfig, 'properties' | 'objects' | 'select'> {
      return this.handler.dynamicInputsSection(this.lowerQ, this.certificate);
    },
    treeContext(): IDynamicTreeContext {
      return {
        parent: this.certificate,
        isTopLevelCollectionAssigned: this.handler.variable.isCollection,
      };
    },
  },
});
</script>